import React from "react";
import { useContext } from "react";
import "./safeAssemblePoint.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { SafeAssemblePointContext } from "../SafeAssemblePointView";
import DataTable from "../../../components/DataTableComponent/DataTable";
import { CardComponent } from "../../../components/CardComponent/CardComponent";
import { Spinner } from "react-bootstrap";
const SafeAssemblePointPage = ({ textContents }) => {
  const {
    setStatusData,
    pageNumber,
    pageCount,
    alertMessage,
    showAlert,
    setShowAlert,
    onPageChange,
    statusCode,
    logout,
    spinnerStatus,
    zoneTotalCount,
    listData,
    assembleCount,
    onCLickZoneOne,
    onCLickZoneTwo,
    activeCardZone1,
    activeCardZone2,
  } = useContext(SafeAssemblePointContext);

  return (
    <div className="safeZone">
      {spinnerStatus && (
        <div className="spinner-overlay-report">
          <Spinner size="xl" className="custom-spinner-report" />
        </div>
      )}
      <TopBar />

      <Container>
        <Row className="mt-5">
          <Col className="cursor-pointer pl-0">
            <CardComponent
              title={textContents.zone1}
              value={zoneTotalCount?.zone1Count || 0}
              name={textContents.zoneOneName}
              active={activeCardZone1}
              onClick={onCLickZoneOne}
            />
          </Col>
          <Col className="cursor-pointer pr-0">
            <CardComponent
              title={textContents.zone2}
              value={zoneTotalCount?.zone2Count || 0}
              name={textContents.zoneTwoName}
              active={activeCardZone2}
              onClick={onCLickZoneTwo}
            />
          </Col>
        </Row>
        <Tabs onSelect={(e) => setStatusData(e)}>
          <Tab
            eventKey="1"
            title={`${textContents.safeAssemblePoint} (${
              assembleCount?.safeAssembleCount || 0
            })`}
          >
            <DataTable
              tableData={listData}
              header={textContents.tableHeaders}
              pageCount={pageCount}
              currentPage={pageNumber}
              onPageChange={(e) => {
                onPageChange(e);
              }}
            />
          </Tab>
          <Tab
            eventKey="0"
            title={`${textContents.remainingCount} (${
              assembleCount?.remainingCount || 0
            })`}
          >
            <DataTable
              tableData={listData}
              header={textContents.tableHeaders}
              pageCount={pageCount}
              currentPage={pageNumber}
              onPageChange={(e) => {
                onPageChange(e);
              }}
            />
          </Tab>
        </Tabs>
        <AlertBox
          show={showAlert}
          setShow={setShowAlert}
          alertMessage={alertMessage}
          handleSubmit={
            statusCode == 401 ? () => logout() : () => setShowAlert(false)
          }
        />
      </Container>
    </div>
  );
};

export default SafeAssemblePointPage;
